var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscovery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.09 19v-1.556c0-.825-.344-1.616-.958-2.2a3.36 3.36 0 00-2.314-.91H6.273c-.868 0-1.7.327-2.314.91a3.035 3.035 0 00-.959 2.2V19m18 0v-1.556c0-.689-.242-1.358-.686-1.903a3.29 3.29 0 00-1.768-1.107m-3.273-9.333a3.29 3.29 0 011.773 1.106c.446.546.688 1.217.688 1.908 0 .69-.242 1.362-.688 1.908a3.29 3.29 0 01-1.773 1.106M12.818 8.11c0 1.718-1.465 3.111-3.273 3.111-1.807 0-3.272-1.393-3.272-3.11C6.273 6.391 7.738 5 9.545 5c1.808 0 3.273 1.393 3.273 3.111z",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscovery);
export default __webpack_public_path__ + "static/media/discovery.10b918d8.svg";
export { ForwardRef as ReactComponent };